<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>ประกาศงานขนส่งใหม่</h2>
      </b-col>
      <b-col>
        <b-button
          @click="$router.push({ name: 'ใบขอราคาทั้งหมด', params: { tabName: 'all' }})"
          class="float-right"
          variant="danger"
        >ยกเลิก</b-button>
      </b-col>
      <!-- <b-col>
        <b-button v-if="step === 0" class="float-right ml-4" variant="primary" @click="next">ถัดไป</b-button>
        <b-button v-else class="float-right ml-4" variant="primary" @click="save">บันทึก</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col> -->
    </b-row>
    <MainForm ref="quoteMainForm"/>
    <!-- <b-row class="mt-2 mb-2">
      <b-col>
        <b-button v-if="step === 0" class="float-right ml-4" variant="primary" @click="next">ถัดไป</b-button>
        <b-button v-else class="float-right ml-4" variant="primary" @click="save">บันทึก</b-button>
        <b-button class="float-right" @click="goBack" variant="warning">ย้อนกลับ</b-button>
      </b-col>
    </b-row> -->
  </div>
</template>

<script>
import TextInput from '../../components/TextInput'
import SelectInput from '../../components/SelectInput'
import MainForm from './MainForm'

import { validationMixin } from 'vuelidate'
import { required, email, helpers, url } from 'vuelidate/lib/validators'

import datePicker from '../../components/LogistyDatePicker/DatePicker'
const thPhoneNumber = helpers.regex('thPhoneNumber', /^0[0-9]{9}$/)

export default {
  mixins: [validationMixin],
  components: {
    TextInput,
    SelectInput,
    datePicker,
    MainForm
  },
  validations: {
    form: {
      customerJobId: {

      },
      title: {
        required
      },
      jobType: {
        required
      },
      frequency: {
        required
      },
      startDate: {
        required
      }
    }
  },
  data () {
    return {
      step: 0,
      form: {
        customerJobId: null,
        title: null,
        jobType: null,
        frequency: null,
        startDate: null
      },
      jobTypeOptions: [
        { value: 'งานครั้งเดียว', text: 'งานครั้งเดียว' },
        { value: 'งานประจำ', text: 'งานประจำ' }
      ],
      dateOptions: {
        format: 'YYYY/MM/DD',
        useCurrent: true
      }
    }
  },
  mounted () {
    window.analytics.track('quote-create-open')
    this.$watch(
      '$refs.quoteMainForm.step',
      (new_value, old_value) => {
        this.step = new_value
      }
    )
  },
  methods: {
    save () {
      Window.Event.$emit('saveQuoteForm')
    },
    next () {
      Window.Event.$emit('quoteTabNext')
    },
    goBack () {
      Window.Event.$emit('quoteTabBack')
    }
  }
}
</script>
